var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-container"},[_c('Header',{attrs:{"title":"预览"}}),_c('div',{staticClass:"t-container main"},[_c('img',{attrs:{"src":_vm.fileAddress}}),_c('p',[_vm._v(_vm._s(_vm.fileName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }